import { useEffect, type ReactNode } from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import { IntlProvider } from 'react-intl'
import { useAccount } from '../../client/modules/account/AccountProvider'
import { getTheme } from '../../theme'
import enMessages from '../../locales/en.json'
import arMessages from '../../locales/ar.json'
import { useLocation } from 'react-router-dom'

const messages = {
  'en-us': enMessages,
  ar: arMessages
}

export function LocaleShell({ children }: { children: ReactNode }) {
  const { locale } = useAccount()
  const { pathname } = useLocation()
  const direction = locale === 'ar' ? 'rtl' : 'ltr'
  const isInternalRoute = pathname !== '/'

  useEffect(() => {
    document.documentElement.dir = direction
    document.documentElement.lang = locale
  }, [locale, direction])

  return (
    <ChakraProvider theme={getTheme(direction, isInternalRoute)}>
      <IntlProvider
        locale={locale}
        messages={messages[locale]}
        defaultLocale="en-us"
      >
        {children}
      </IntlProvider>
    </ChakraProvider>
  )
}
